<template>
  <button
    type="button"
    :disabled="disabled"
    class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:shadow-none disabled:border-transparent disabled:text-gray-500"
    @click="openSendTestDialog"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
      /></svg
    ><span
      class="sr-only lg:not-sr-only lg:ml-2"
      :class="[disabled ? 'text-gray-500' : 'text-gray-900']"
      >Test</span
    >
  </button>
</template>

<script>
export default {
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    openSendTestDialog() {
      this.$modal.show({
        component: () => import('./SendTestDialog.vue'),
        props: {
          emailCampaign: this.emailCampaign,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
